export const FETCH_DIAGRAM_TEMPLATES = "FETCH_DIAGRAM_TEMPLATES";
export const FETCH_DIAGRAM_TEMPLATES_START = "FETCH_DIAGRAM_TEMPLATES_START";
export const FETCH_DIAGRAM_TEMPLATES_SUCCESS = "FETCH_DIAGRAM_TEMPLATES_SUCCESS";
export const FETCH_DIAGRAM_TEMPLATES_ERROR = "FETCH_DIAGRAM_TEMPLATES_ERROR";

export const ADD_UPDATE_DIAGRAM_TEMPLATE = "ADD_UPDATE_DIAGRAM_TEMPLATE";
export const ADD_UPDATE_DIAGRAM_TEMPLATE_SUCCESS = "ADD_UPDATE_DIAGRAM_TEMPLATE_SUCCESS";
export const ADD_UPDATE_DIAGRAM_TEMPLATE_ERROR = "ADD_UPDATE_DIAGRAM_TEMPLATE_ERROR";

export const DELETE_DIAGRAM_TEMPLATE = "DELETE_DIAGRAM_TEMPLATE";
export const DELETE_DIAGRAM_TEMPLATE_SUCCESS = "DELETE_DIAGRAM_TEMPLATE_SUCCESS";
export const DELETE_DIAGRAM_TEMPLATE_ERROR = "DELETE_DIAGRAM_TEMPLATE_ERROR";

export const ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE = "ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE";
export const ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS = "ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS";
export const ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR = "ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR";

export const DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE = "DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE";
export const DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS = "DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS";
export const DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR = "DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR";

export const FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES = "FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES";
export const FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_START = "FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_START";
export const FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_SUCCESS = "FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_SUCCESS";
export const FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_ERROR = "FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_ERROR";

export const FETCH_GROUP_DIAGRAM_TEMPLATES = "FETCH_GROUP_DIAGRAM_TEMPLATES";
export const FETCH_GROUP_DIAGRAM_TEMPLATES_SUCCESS = "FETCH_GROUP_DIAGRAM_TEMPLATES_SUCCESS";
export const FETCH_GROUP_DIAGRAM_TEMPLATES_ERROR = "FETCH_GROUP_DIAGRAM_TEMPLATES_ERROR";

export const RESET_DIAGRAM_TEMPLATES = "RESET_DIAGRAM_TEMPLATES";

export const fetchDiagramTemplates = () => {
  return {
      type: FETCH_DIAGRAM_TEMPLATES,
  };
};

export const deleteDiagramTemplate = (diagramTemplateId) => {
  return {
      type: DELETE_DIAGRAM_TEMPLATE,
      payload: diagramTemplateId
  }
}

export const addUpdateDiagramTemplate = (diagramTemplate) => {
  return {
      type: ADD_UPDATE_DIAGRAM_TEMPLATE,
      payload: diagramTemplate
  }
}

export const fetchPublicCategorizedDiagramTemplates = () => {

  return {
      type: FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES,
  };
};

export const fetchGroupDiagramTemplates = () => {
  return {
      type: FETCH_GROUP_DIAGRAM_TEMPLATES,
  };
};

export const resetDiagramTemplates = () => {
  return {
      type: RESET_DIAGRAM_TEMPLATES
  }
}

export const addUpdatePublicCategorizedDiagramTemplate = (publicDiagramTemplate) => {

  return {
      type: ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE,
      payload: publicDiagramTemplate
  };
};

export const deleteUpdatePublicCategorizedDiagramTemplates = (publicDiagramTemplate) => {

  return {
      type: DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE,
      payload: publicDiagramTemplate
  };
};